import { observer } from "mobx-react";

import BaseComponent from "@component/BaseComponent";
import List from "./List";

@observer
export default class Dependents extends BaseComponent<PropsFromRouter> {
  render() {
    return (
      <>
        <List match={this.props.match} />
      </>
    );
  }
}
